import React, { useState, useEffect, useContext } from 'react';
import { Card, Row, Col, Button, Popconfirm, message } from 'antd';
import Title from '../../components/Title/Title';
import axios from '../../util/Api';
import { ParamsContext } from '../Context/ParamsContext';
import Item from '../../components/Detail/Item';
import DateTime from '../../components/Formatter/DateTime';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

const Detail = (props) => {
  const { id } = useContext(ParamsContext);
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);

  const history = useHistory();

  useEffect(() => {
    fetchUserDetail();
  }, [id]);

  const fetchUserDetail = () => {
    setLoading(true);
    const url = `/user/detail?id=${id}`;
    axios.get(url).then(resp => {
      setUser(resp.data);
      setLoading(false);
    }).catch(err => {});
  }

  const handleDelete = () => {
    setIsDeleting(true);
    const url = `/user/delete?id=${id}`;
    axios.post(url, {}).then(resp => {
      message.success("User telah berhasil dihapus");
      setIsDeleting(false);
      history.push(`/users`);
    }).catch(err => {
      message.error("Gagal menghapus user");
      setIsDeleting(false);
    });
  }

  return (
    <>
      <Title>Detail User</Title>
      {loading ? "Sedang memuat..." : (
        <Row>
          <Col span={12}>
            <Card className="gx-card" title={user.name}>
              <Item label="Email" value={user.email} />
              <Item label="Status" value={user.status.label} />
              <Item label="Role" value={user.role.label} />
              {user.project ? <Item label="Proyek" value={user.project.name} /> : null}
              <Item label="Dibuat" value={<DateTime value={user.created_at} />} />
              <Item label="Terakhir Diperbarui" value={<DateTime value={user.updated_at} />} />
              <div className="gx-mt-2">
                <Row>
                  <Col span={8}>
                    <Link to={`/users`}><Button type="default">Kembali</Button></Link>
                  </Col>
                  <Col span={16} className="gx-text-right">
                    <Link to={`/users/update?id=${user.id}`} className="gx-ml-2"><Button type="primary" >Perbarui</Button></Link>
                    {user.actions.delete ? (
                      <Popconfirm
                        title="Apakah Anda yakin ingin menghapus user ini?"
                        onConfirm={handleDelete}
                        onCancel={()=>{}}
                        okText="Hapus"
                        cancelText="Batal"
                      >
                        <Button type="default" danger className="gx-ml-2" loading={isDeleting}>Hapus</Button>
                      </Popconfirm>
                    ) : null}
                  </Col>
                </Row>
                
              </div>
            </Card>
          </Col>
          <Col span={12}></Col>
        </Row>
      )}
    </>
  );
}

export default Detail;